export const HELP_LINKS = {
  otpOffersMigration:
    'https://help.playbookapp.io/en/articles/15924965-otp-programs-otp-offers-what-s-changing-and-what-s-not',
} as const;
